export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';



// WEBPACK FOOTER //
// ./src/actions/snackbar/actionTypes.js